module.exports = __webpack_public_path__ + "src/assets/scan_history_downloaded.png";